import { computed, ref } from 'vue';
import { useDebouncedRef } from '@/composables/use-debounced-ref';
import {
  SPORT_LIVE_TV_DEFAULT_SORT,
  SPORT_LIVE_TV_DEFAULT_STATUS,
  SPORT_LIVE_TV_FILTER_GROUPS,
  SPORT_LIVE_TV_STATUSES,
  SPORT_LIVE_TV_TEAMS_SEARCH_DELAY_MS,
  createSportLiveTvEmptySelection,
} from '@/sport-live-tv/constants';
import { toggleSportLiveTvValue } from '@/sport-live-tv/helpers';

export const useSportLiveTvFilters = () => {
  const applied = ref(createSportLiveTvEmptySelection());
  const draft = ref(createSportLiveTvEmptySelection());
  const sort = ref(SPORT_LIVE_TV_DEFAULT_SORT);
  const status = ref(SPORT_LIVE_TV_DEFAULT_STATUS);
  const scoresVisible = ref(false);
  const teamsSearch = ref('');

  const debouncedTeamsSearch = useDebouncedRef(teamsSearch, SPORT_LIVE_TV_TEAMS_SEARCH_DELAY_MS);

  const isFiltered = computed(() => applied.value.leagues.length > 0 || applied.value.teams.length > 0);

  const toggle = (group, value) => {
    draft.value =
      group === SPORT_LIVE_TV_FILTER_GROUPS.leagues
        ? { ...draft.value, leagues: toggleSportLiveTvValue(draft.value.leagues, Number(value)) }
        : { ...draft.value, teams: toggleSportLiveTvValue(draft.value.teams, value) };
  };

  const applyFilters = () => {
    applied.value = draft.value;
  };

  const selectLeague = (leagueId) => {
    const selection = { leagues: [leagueId], teams: [] };

    draft.value = selection;
    applied.value = selection;
  };

  const showLive = () => {
    status.value = SPORT_LIVE_TV_STATUSES.live;
  };

  const toggleScores = () => {
    scoresVisible.value = !scoresVisible.value;
  };

  const clearFilters = () => {
    draft.value = createSportLiveTvEmptySelection();
    applied.value = createSportLiveTvEmptySelection();
    sort.value = SPORT_LIVE_TV_DEFAULT_SORT;
    status.value = SPORT_LIVE_TV_DEFAULT_STATUS;
  };

  return {
    applied,
    draft,
    sort,
    status,
    scoresVisible,
    teamsSearch,
    debouncedTeamsSearch,
    isFiltered,
    toggle,
    applyFilters,
    selectLeague,
    showLive,
    toggleScores,
    clearFilters,
  };
};
